import batchHandleUrl from '../../../utils/url-handle'

const Api = {
  // 值对象-对象的主属性列表
  getMainFieldList: {
    url: '/apaas/object/value/mainFieldList',
    type: 'post'
  },
  // 值对象-对象的主属性列表
  getRelationMainFieldList: {
    url: '/apaas/object/value/relationMainFieldList',
    type: 'post'
  },
  // 值对象-查找关联列表
  mainFieldAllTabList: {
    url: '/apaas/object/value/mainFieldAllTabList',
    type: 'post'
  },
  // 值对象-一方对象中查找关联的布局信息
  getRelationLayoutByField: {
    url: '/apaas/layout/getLookUpRelationPage',
    type: 'post'
  }
}

export default batchHandleUrl(Api)